module.exports = __webpack_public_path__ + "img/nav-right-search-below-hyundai.13e350d2.png";